import { createContext, useContext } from 'react';
import { UserDevicesContextType } from './type';

export const UserDevicesContext = createContext({} as UserDevicesContextType);
export const useUserDevicesContext = () => {
  const context = useContext(UserDevicesContext);
  if (!context) {
    throw new Error('useUserDevicesContext must be used within a UserDevicesContextProvider');
  }
  return context;
};
